const createProjectDialog = {
  title: "Create New Project",
  titleLabel: "Project Title *",
  titlePlaceholder: "e.g., Cardiovascular Research Study",
  descriptionLabel: "Project Description *",
  creating: "Creating...",
  submit: "Create Project",
  errors: {
    titleRequired: "Project title is required",
    descriptionRequired: "Project description is required",
    createFailed: "Failed to create project",
  },
};

export default createProjectDialog;
